
import Navbar4 from "../../../src/components/IVRVue/Navbar4";
import Footer from "../../../src/components/IVRVue/Footer";
import Main from "../../../src/components/IVRVue/Main";
const IVRVue = () => {
  return (
    <div>
      <Navbar4 />
      <Main/>
      <Footer />
    </div>
  );
};

export default IVRVue;
